import React from 'react';
import { useState, useEffect, Fragment } from "react";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import DataTable from 'react-data-table-component';
import addRolesAndRightsJson from '../../../json-data/get-roles-and-rights.json';
import CreateRolesAndRights from './Modal-Dialog/create-roles-and-rights';
import EditRolesAndRights from './Modal-Dialog/edit-roles-and-rights';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import Popover from 'react-bootstrap/Popover';
import { PiPencilSimpleLine } from "react-icons/pi";
import { IoAddCircle, IoTrashBin } from "react-icons/io5";
import { PiTrashThin, PiNotePencilBold } from "react-icons/pi";
import { PiTrashDuotone } from "react-icons/pi";
import { configData } from "../../../config/systemconfigurationconstants";
import * as AWS from 'aws-sdk';
import lambdaConfig from "../../../hooks/lambdaConfig";
import UseLambdaInvocations from "../../../hooks/useLambdaInvocations";
import { ToastContainer, toast } from "react-toastify";
import { FaPlusCircle } from 'react-icons/fa';
import { useEncryption } from '../../../customHooks/useEncryption';
const AddRolesAndRights = () => {
    const { invokeLambda, loading, error } = UseLambdaInvocations();

    const [roles, setRoles] = useState([]);
    const [rights, setRights] = useState([]);
    const [popoverTarget, setPopoverTarget] = useState(null);
    const [selectedRole, setSelectedRole] = useState(null);
    const [selectedRight, setSelectedRight] = useState(null);
    const [popoverTargetRight, setPopoverTargetRight] = useState(null);



    const [editRolesAndRights, setEditRolesAndRights] = useState(false);
    const [showAddRights, setShowAddRights] = useState(false);
    const [showRolesAndRights, setShowRolesAndRights] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [dotloader, setDotLoader] = useState(false);
    const { encrypt, decrypt } = useEncryption();
    const getCookie = (name) => {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) {
            return decodeURIComponent(parts.pop().split(';').shift());
        }
        return null;
    };
    const lambda = new AWS.Lambda({
        region: configData.LAMBDA_REGION,
        accessKeyId: decrypt(getCookie('ak')),
        secretAccessKey: decrypt(getCookie('sk'))
    });
    useEffect(() => {

        getRolesAndRights();

    }, [])
    const getRolesAndRights = async () => {
        setDotLoader(true);
        try {
            const parsedBody = await invokeLambda(configData.GET_ROLES_RIGHTS, {
                ...lambdaConfig,
                SecurityToken: localStorage.getItem('SecurityToken'),

            });

            if (parsedBody.Status) {

                setRoles(parsedBody.AllRoles)
                setRights(parsedBody.AllRights)
                setTimeout(() => setDotLoader(false), 1000);

            } else {
                setDotLoader(false);

            }
        } catch (err) {
            // Handle error if needed
            setDotLoader(false);

        }
    }


    const addRolesAndRights = () => setShowRolesAndRights(true);
    const closeRolesAndRights = () => setShowRolesAndRights(false);
    const editRole = (row) => {
        setSelectedRow(row);
        setShowAddRights(false); // show role form
        setEditRolesAndRights(true);
    };
    const editRight = (row) => {
        setSelectedRow(row);
        setShowAddRights(true); // show rights form
        setEditRolesAndRights(true);
    };
    const closeEditRole = () => {
        setEditRolesAndRights(false);
        setSelectedRow(null);
    };
    const handleDeleteRole = async () => {
        // setDotLoader(true);
        let delete_Role;
        delete_Role = {
            RoleId: selectedRole.RoleMasterId
        };

        if (selectedRole) {
            setRoles(prev => prev.filter(role => role.RoleMasterId !== selectedRole.RoleId));
            setSelectedRole(null);
            setPopoverTarget(null);
        }
        try {
            const parsedBody = await invokeLambda(configData.EDIT_DELETE_ROLES_RIGHTS, {
                ...lambdaConfig,
                SecurityToken: localStorage.getItem('SecurityToken'),
                RoleRightsJSON: { DeleteRoles: delete_Role, DeleteRights: null }

            });

            if (parsedBody.Status) {
                toast.success("Role deleted Successfully", {
                    position: "bottom-center",
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
                getRolesAndRights();
                setTimeout(() => setDotLoader(false), 1000);
            } else {
                toast.success("Error in delete Roles", {
                    position: "bottom-center",
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
                setTimeout(() => setDotLoader(false), 1000);


            }
        } catch (err) {

            setDotLoader(false);

        }
    };

    const handleDeleteRight = async () => {
        let delete_Right;
        delete_Right = {
            RightId: selectedRight.RightId
        };
        if (selectedRight) {
            setRights(prev => prev.filter(r => r.RightId !== selectedRight.RightId));
            setSelectedRight(null);
            setPopoverTargetRight(null);
        }
        try {
            const parsedBody = await invokeLambda(configData.EDIT_DELETE_ROLES_RIGHTS, {
                ...lambdaConfig,
                SecurityToken: localStorage.getItem('SecurityToken'),
                RoleRightsJSON: { DeleteRoles: null, DeleteRights: delete_Right }

            });

            if (parsedBody.Status) {

                toast.success("Right Deleted!", {
                    position: "bottom-center",
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
                getRolesAndRights();

            } else {
                toast.success("Error in delete Rights", {
                    position: "bottom-center",
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });


            }
        } catch (err) {
            // setDotLoader(false);

        }
    };

    const deleteRole = (
        <Popover id="popover-delete-confirmation">
            <Popover.Header as="h3">Delete Role</Popover.Header>
            <Popover.Body>
                Do you want to delete this role?
                <div className="mt-2 d-flex justify-content-end gap-2">

                    <Button
                        variant="primary"
                        size="sm"
                        onClick={handleDeleteRole}
                    >
                        <PiTrashThin className="shake-icon" style={{ fontSize: '16px' }} /> Delete
                    </Button>
                </div>
            </Popover.Body>
        </Popover>
    );
    const deleteRightPopover = (
        <Popover id="popover-delete-confirmation">
            <Popover.Header as="h3">Delete Right</Popover.Header>
            <Popover.Body>
                Do you want to delete this Right?
                <div className="mt-2 d-flex justify-content-end gap-2">

                    <Button
                        variant="primary"
                        size="sm"
                        onClick={handleDeleteRight}
                    >
                        <PiTrashThin className="shake-icon" style={{ fontSize: '16px' }} /> Delete
                    </Button>
                </div>
            </Popover.Body>
        </Popover>
    );

    const addrolescolumns = [
        {
            name: 'Role Name',
            selector: row => row.RoleName,
            sortable: true,
        },
        {
            name: 'Role Description',
            selector: row => row.RoleDescription,
            sortable: true,
        },
        {
            name: 'Action',
            cell: row => (
                <div className='d-flex justify-content-evenly w-100'>

                    <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip id={`tooltip-edit-${row.id}`}>Edit</Tooltip>}
                    >
                        <div onClick={() => editRole(row)} className='icon edit'>
                            <PiNotePencilBold />
                        </div>
                    </OverlayTrigger>


                    <OverlayTrigger
                        trigger="click"
                        placement="left"
                        overlay={deleteRole}
                        rootClose >
                        <span>
                            <OverlayTrigger
                                placement="top"
                                overlay={<Tooltip id={`tooltip-delete-${row.id}`}>Delete</Tooltip>}
                            >
                                <div
                                    className='icon delete'
                                    onClick={() => setSelectedRole(row)}
                                >
                                    <IoTrashBin />
                                </div>
                            </OverlayTrigger></span>
                    </OverlayTrigger>


                </div>
            )
        }
    ];
    const addrightscolumns = [
        {
            name: 'Right Type	',
            selector: row => row.DisplayName,
            sortable: true,
        },
        {
            name: 'Right Description',
            selector: row => row.RightDescription,
            sortable: true,
        },
        {
            name: 'Action',
            cell: row => (
                <div className='d-flex justify-content-evenly w-100'>
                    <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip id={`tooltip-edit-${row.id}`}>Edit</Tooltip>}
                    >
                        <div onClick={() => editRight(row)} className='icon edit'>
                            <PiNotePencilBold />
                        </div>
                    </OverlayTrigger>
                    <OverlayTrigger
                        trigger="click"
                        placement="left"
                        overlay={deleteRightPopover}
                        rootClose>
                        <span>
                            <OverlayTrigger
                                placement="top"
                                overlay={<Tooltip id={`tooltip-delete-${row.id}`}>Delete</Tooltip>}
                            >
                                <div
                                    className='icon delete'
                                    onClick={() => setSelectedRight(row)}
                                >
                                    <IoTrashBin />
                                </div></OverlayTrigger></span>
                    </OverlayTrigger>


                </div>
            )
        }
    ];


    const handleSwitchToggle = () => {
        setShowAddRights(prev => !prev);
    };
    const screenWidth = window.innerWidth;
    let minHeight;

    if (screenWidth == 1920) {
        minHeight = '626px';
    } else if (screenWidth == 1680) {
        minHeight = '595px';
    } else if (screenWidth == 1600) {
        minHeight = '448px';
    } 
    // else if (screenWidth == 1280) {
    //     minHeight = '575px';
    // }
     else {
        minHeight = 'calc(100vh - 314px)';
    }
    const customStyles = {
        table: {
            style: {
                minHeight,
                backgroundColor: 'white',
                overflowY: 'auto',
            },
        },

    };

    const handleCreateSubmit = async (formData) => {
        let newRight;
        let newRole;
        if (showAddRights) {
            newRight = {
                RightType: formData.rightType,
                DisplayName: formData.displayName,
                // RightDescription: formData.rightDescription
                RightDesc: formData.rightDescription
            };
            // setRights(prev => [...prev, newRight]);
        }
        else {
            newRole = {
                // RoleMasterId: Date.now(), // or proper ID
                RoleName: formData.roleName,
                // RoleDescription: formData.roleDescription
                RoleDesc: formData.roleDescription
            };
            // setRoles(prev => [...prev, newRole]);

        }

        try {
            const parsedBody = await invokeLambda(configData.ADD_ROLES_RIGHTS, {
                ...lambdaConfig,
                SecurityToken: localStorage.getItem('SecurityToken'),
                RoleRightsJSON: { AddRoles: !showAddRights ? newRole : null, AddRights: showAddRights ? newRight : null }

            });

            if (parsedBody.Status) {
                toast.success(showAddRights ? "Right Added Successfully" : "Role Added Successfully", {
                    position: "bottom-center",
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
                setTimeout(() => setDotLoader(false), 1000);
                await getRolesAndRights();

            } else {
                toast.error(showAddRights ? "Error in adding Right" : "Error in adding Role", {
                    position: "bottom-center",
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
                setTimeout(() => setDotLoader(false), 1000);
                await getRolesAndRights();
            }

        } catch (err) {



        }
    };
    const handleEditRow = async (formData) => {
        console.log(formData);
        let editRight;
        let editRole;
        if (showAddRights) {
            // Update rights
            editRight = {
                RightId: formData.RightId,
                RightType: formData.RightType,
                DisplayName: formData.DisplayName,
                RightDesc: formData.RightDescription
            };
            // setRights(prevRights =>
            //     prevRights.map(right =>
            //         right.RightId === formData.RightId ? { ...right, ...formData } : right
            //     )
            // );
        } else {
            editRole = {
                RoleId: selectedRow.RoleMasterId,
                RoleName: formData.RoleName,
                RoleDesc: formData.RoleDescription
            }
            // Update roles
            // setRoles(prevRoles =>
            //     prevRoles.map(role =>
            //         role.RoleMasterId === selectedRow.RoleMasterId ? { ...role, ...formData } : role
            //     )
            // );
        }
        setEditRolesAndRights(false);
        setSelectedRow(null);

        try {
            const parsedBody = await invokeLambda(configData.EDIT_DELETE_ROLES_RIGHTS, {
                ...lambdaConfig,
                SecurityToken: localStorage.getItem('SecurityToken'),
                RoleRightsJSON: { EditRoles: !showAddRights ? editRole : null, EditRights: showAddRights ? editRight : null }

            });

            if (parsedBody.Status) {
                toast.success(showAddRights ? "Right Edited Successfully" : "Role Edited Successfully", {
                    position: "bottom-center",
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
                setTimeout(() => setDotLoader(false), 1000);
                getRolesAndRights();
            } else {
                toast.error(showAddRights ? "Right Edit Failed" : "Role Edit Failed", {
                    position: "bottom-center",
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
                setDotLoader(false);
            }

        } catch (err) {
            setDotLoader(false);

        }

    }
    return (
        <>
            <Row>
                <Col sm={6} className='d-flex align-items-center'>
                    <Form className='toggle-switch'>
                        <div className="d-flex align-items-center gap-2">
                            <Form.Label
                                className={`mb-0 ${!showAddRights ? 'gradient-text' : ''}`}>
                                Add Roles
                            </Form.Label>
                            <Form.Check
                                type="switch"
                                id="custom-switch"
                                label={
                                    <span className={showAddRights ? 'gradient-text' : ''}>
                                        Add Rights
                                    </span>
                                }
                                checked={showAddRights}
                                onChange={handleSwitchToggle}
                            />
                        </div>
                    </Form>
                </Col>
                <Col sm={6} className='text-end mb-1'>
                    <Button variant="primary" size='sm' onClick={addRolesAndRights}> {showAddRights ? 'Create Right' : 'Create Role'}</Button>
                </Col>
            </Row>
            <Row>
                <Col sm={12} className={showAddRights ? 'add-rights' : 'add-roles'}>
                    {dotloader ? (
                        <div className="d-flex justify-content-center">
                            <div className="loader"></div>
                        </div>
                    ) : (
                        <DataTable
                            columns={showAddRights ? addrightscolumns : addrolescolumns}
                            data={showAddRights ? rights : roles}
                            dense
                            customStyles={customStyles}
                            pagination
                        />
                    )}
                </Col>

            </Row>
            <CreateRolesAndRights show={showRolesAndRights} handleClose={closeRolesAndRights} mode={showAddRights ? 'rights' : 'role'} onSubmit={handleCreateSubmit} />
            <EditRolesAndRights show={editRolesAndRights} handleClose={closeEditRole} mode={showAddRights ? 'rights' : 'role'} data={selectedRow} onSave={handleEditRow} disableRightType={showAddRights} />
        </>

    );
};

export default AddRolesAndRights;